import CryptoJS from "crypto-js";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
const AES_KEY = "drive_encrypt_pc";
const AES_IV = "drive_encrypt_pc";

// 密码解密
export const AESDecrypt = (text: string) => {
  const decrypted = CryptoJS.AES.decrypt(
    text,
    CryptoJS.enc.Utf8.parse(AES_KEY),
    {
      iv: CryptoJS.enc.Utf8.parse(AES_IV),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }
  );
  return decrypted.toString(CryptoJS.enc.Utf8);
};

// 密码加密
export const AESEncrypt = (text: string) => {
  const decrypted = CryptoJS.AES.encrypt(
    text,
    CryptoJS.enc.Utf8.parse(AES_KEY),
    {
      iv: CryptoJS.enc.Utf8.parse(AES_IV),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }
  );
  return decrypted.toString();
};

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault('Asia/Shanghai');

export const formatTime = (time: string): string => {
  if (!time) return "";
  try {
    return dayjs.utc(time).tz('Asia/Shanghai').format("YYYY-MM-DD HH:mm:ss");
  } catch (error) {
    console.error("日期格式化错误:", error);
    return "";
  }
};
export async function uploadFile(
  url: string,
  formData: FormData,
  headers: Record<string, string> = {}
) {
  return fetch(url, {
    method: "POST",
    credentials: "omit",
    headers: {
      "workspace-session": AESDecrypt(
        sessionStorage.getItem("sessionId") || ""
      ),
      // 不要设置 Content-Type，浏览器会自动加上 boundary
      ...headers,
    },
    body: formData,
  }).then(async (res) => {
    if (!res.ok) {
      throw new Error(
        `Request failed with status ${res.status}: ${res.statusText}`
      );
    }
    return res.json();
  });
}
export async function downloadFile(res: any, fileName: string) {
  const blob = new Blob([res.data], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;",
  });
  let a = document.createElement("a");
  const contentDisposition = res?.headers?.["content-disposition"];
  const name = contentDisposition.split("filename=")[1].replace(/"/g, "");
  a.download = decodeURIComponent(name);
  a.href = URL.createObjectURL(blob);
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}
//状态展示
export function getStatusInfo(status: string, plannedCompleteTime?: string) {
  const now = dayjs();

  const plannedTime = plannedCompleteTime ? dayjs(plannedCompleteTime) : null;

  const daysOverdue = plannedTime
    ? Math.ceil(now.diff(plannedTime, "day", true))
    : 0;

  if (plannedTime && daysOverdue > 0 && status !== "SUCCESS" && status !== "FAILED") {
    return { text: `已延期${daysOverdue}天`, color: "warning" };
  }

  if (status === "SUCCESS") {
    return { text: "已完成", color: "success" };
  }

  if (status === "FAILED") {
    return { text: "已失败", color: "error" };
  }

  if (status === "PENDING") {
    return { text: "未开始", color: "default" };
  }

  if (status === "RUNNING") {
    return { text: "进行中", color: "processing" };
  }

  if (status === "PENDING_APPROVAL") {
    return { text: "待审批", color: "warning" };
  }

  if (status === "EXPIRED") return { text: "已失效", color: "default" };
  if (status === "CANCELLED") return { text: "已取消", color: "default" };
  return { text: "未知状态", color: "default" };
}

// 计划完结状态：已完成/已失败/已失效/已取消
export const TERMINAL_PLAN_STATUSES = ["SUCCESS", "FAILED", "EXPIRED", "CANCELLED"];

export const isPlanTerminal = (status?: string): boolean =>
  !!status && TERMINAL_PLAN_STATUSES.includes(status);

// 实际完成时间：完结状态的计划必须展示，优先 finishedTime，缺失时兜底为"变更成完结状态的时间"(updateTime)
export const getPlanActualFinishTime = (plan?: any): string => {
  if (!plan) return "";
  if (isPlanTerminal(plan.status)) {
    return plan.finishedTime || plan.updateTime || "";
  }
  return plan.finishedTime || "";
};


export const getUserInfoFromLocalStorage = () => {
  if (typeof window !== 'undefined') {
    try {
      const userInfo = sessionStorage.getItem('userInfo');
      const userRoles = sessionStorage.getItem('userRoles');
      const sessionId = sessionStorage.getItem('sessionId');
      const permissions = sessionStorage.getItem('permissions');
      
      return {
        userInfo: userInfo ? JSON.parse(AESDecrypt(userInfo)) : null,
        userRoles: userRoles ? JSON.parse(AESDecrypt(userRoles)) : [],
        sessionId: sessionId || null,
        permissions: permissions ? JSON.parse(AESDecrypt(permissions)) : [] 
      };
    } catch (error) {
      console.error('从 localStorage 读取用户信息失败:', error);
      return {
        userInfo: null,
        userRoles: [],
        sessionId: null,
        permissions: []
      };
    }
  }
  return {
    userInfo: null,
    userRoles: [],
    sessionId: null,
    permissions: []
  };
};

// 清理 localStorage 中的用户信息
export const clearUserInfoFromLocalStorage = () => {
  if (typeof window !== 'undefined') {
    try {
      sessionStorage.removeItem('userInfo');
      sessionStorage.removeItem('userRoles');
      sessionStorage.removeItem('sessionId');
      sessionStorage.removeItem('loginTime');
      sessionStorage.removeItem('permissions');
      console.log('用户信息已从 sessionStorage 清除');
    } catch (error) {
      console.error('清理 sessionStorage 失败:', error);
    }
  }
};
